export const lists_BuildingInformation = [
    {
        "ID": 0,
        "name": "Brandweer, Kazerne",
        "smallBuildingId": 17,
        "extentions": [
            "Ambulance standplaats",
            "Waterongevallenbestrijding",
            "Vliegtuigbrandbestrijding",
            "Haakarmbak parkeerplaats",
            "Schuimblussing",
            "Signalisatie",
            "Natuurbrandbestrijding",
            "Urban Search and Rescue",
            "Specialisme Technische Hulpverlening",
            "Grote brandweerkazerne"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 1,
        "name": "Meldkamer",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 2,
        "name": "Ziekenhuis",
        "extentions": [
            "Interne Geneeskunde",
            "Algemene Heelkunde",
            "Gynaecologie",
            "Urologie",
            "Traumatologie",
            "Neurologie",
            "Neurochirurgie",
            "Cardiologie",
            "Cardiochirurgie",
            "Groot ziekenhuis"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 3,
        "name": "Ambulance, Standplaats",
        "smallBuildingId": 13,
        "extentions": [
            "Grote ambulancepost"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 4,
        "name": "Brandweer, Academie",
        "extentions": [
            "Extra klaslokaal"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 5,
        "name": "Politie, Opkomstbureau",
        "smallBuildingId": 18,
        "extentions": [
            "Gevangeniscel",
            "Extra cel",
            "Groot politiebureau",
            "Grote gevangenis",
            "LE - Dienst Infrastructuur"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 6,
        "name": "MMT, Standplaats",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 7,
        "name": "Universiteit Faculteit Geneeskunde",
        "extentions": [
            "Extra klaslokaal"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 8,
        "name": "Politie, Academie",
        "extentions": [
            "Extra klaslokaal"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 9,
        "name": "Politiehelikoper standplaats",
        "LevelCountAsBuilding": true,
        "BuildingCounter": true,
    },
    {
        "ID": 10,
        "name": "Uitgangstelling (UGS)",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 11,
        "name": "Politie, Hoofdbureau",
        "extentions": [
            "2e OvD-P",
            "Arrestantenvervoer",
            "Mobiele Eenheid, Sectie",
            "Mobiele Eenheid, 2e Sectie",
            "Mobiele Eenheid, Aanhoudingseenheid",
            "Hondenbrigade",
            "Bereden Brigade",
            "Arrestatieteam",
            "Waterwerper Uitbreiding"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 12,
        "name": "Politie, Cellencomplex voor teams",
        "extentions": [
            "Gevangeniscel",
            "Extra cel",
            "Grote gevangenis"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 13,
        "name": "Ambulance, VWS-post",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 14,
        "name": "Groot gebouwencomplex",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 15,
        "name": "Klein gebouwencomplex",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 16,
        "name": "Waterreddingspost",
        "extentions": [
            "Boten"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 17,
        "name": "Brandweer, Kazerne (Klein)",
        "extentions": [
            "Ambulance standplaats",
            "Waterongevallenbestrijding",
            "Vliegtuigbrandbestrijding",
            "Haakarmbak parkeerplaats",
            "Schuimblussing",
            "Signalisatie",
            "Natuurbrandbestrijding",
            "Urban Search and Rescue",
            "Specialisme Technische Hulpverlening"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 18,
        "name": "Politie, Opkomstbureau (Klein)",
        "extentions": [
            "Gevangeniscel",
            "Extra cel"
        ],
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 19,
        "name": "Kustwacht haven",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 20,
        "name": "SAR academie",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 21,
        "name": "SAR Helikopter platform",
        "LevelCountAsBuilding": false,
        "BuildingCounter": false,
        "ExtensionCountAsBuilding": true,
        "ExtensionPossibleOnBuilding": [21],
        "ExtensionNames": [
            "SAR Helikopter Hangar",
            "Extra SAR Helikopter Hangar"
        ]
    },
    {
        "ID": 22,
        "name": "Steunpunt Rijkswaterstaat",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    },
    {
        "ID": 23,
        "name": "Militaire hangar",
        "LevelCountAsBuilding": false,
        "BuildingCounter": true,
    }
]

export const lists_BuildingExtensionsOverview = [
    {
        "name": "Ambulance standplaats"
    },
    {
        "name": "Waterongevallenbestrijding"
    },
    {
        "name": "Vliegtuigbrandbestrijding"
    },
    {
        "name": "Haakarmbak parkeerplaats"
    },
    {
        "name": "Schuimblussing"
    },
    {
        "name": "Interne Geneeskunde"
    },
    {
        "name": "Algemene Heelkunde"
    },
    {
        "name": "Gynaecologie"
    },
    {
        "name": "Urologie"
    },
    {
        "name": "Traumatologie"
    },
    {
        "name": "Neurologie"
    },
    {
        "name": "Neurochirurgie"
    },
    {
        "name": "Cardiologie"
    },
    {
        "name": "Cardiochirurgie"
    },
    {
        "name": "Extra klaslokaal"
    },
    {
        "name": "Gevangeniscel"
    },
    {
        "name": "Extra cel"
    },
    {
        "name": "2e OvD-P"
    },
    {
        "name": "Arrestantenvervoer"
    },
    {
        "name": "Mobiele Eenheid, Sectie"
    },
    {
        "name": "Mobiele Eenheid, 2e Sectie"
    },
    {
        "name": "Mobiele Eenheid, Aanhoudingseenheid"
    },
    {
        "name": "Hondenbrigade"
    },
    {
        "name": "Bereden Brigade"
    },
    {
        "name": "Arrestatieteam"
    },
    {
        "name": "Boten"
    },
    {
        "name": "SAR Helikopter Hangar"
    },
    {
        "name": "Extra SAR Helikopter Hangar"
    },
    {
        "name": "Signalisatie"
    },
    {
        "name": "Waterwerper Uitbreiding"
    },
    {
        "name": "Natuurbrandbestrijding"
    },
    {
        "name": "Urban Search and Rescue"
    },
    {
        "name": "Specialisme Technische Hulpverlening"
    },
    {
        "name": "Groot ziekenhuis"
    },
    {
        "name": "Groot politiebureau"
    },
    {
        "name": "Grote gevangenis"
    },
    {
        "name": "Grote brandweerkazerne"
    },
    {
        "name": "Grote ambulancepost"
    },
    {
        "name": "LE - Dienst Infrastructuur"
    }
]

export const lists_BuildingSpecialisations = [
    {
        "name": "Luchthaven Specialisatie",
        "type": "airport"
    },
    {
        "name": "Schuimblussing Specialisatie",
        "type": "fire_support"
    },
    {
        "name": "Waterongevallen Specialisatie",
        "type": "water_rescue"
    },
    {
        "name": "Natuurbrandbestrijding Specialisatie",
        "type": "forestry"
    },
    {
        "name": "USAR Specialisatie",
        "type": "search_and_rescue"
    },
    {
        "name": "STH Specialisatie",
        "type": "disaster_response"
    },
    {
        "name": "LE - Dienst Infrastructuur Specialisatie",
        "type": "traffic_police"
    },
]

export const lists_Schools = [
    {
        "name": "Brandweer, Academie",
        "building_id": 4
    },
    {
        "name": "Politie, Academie",
        "building_id": 8
    },
    {
        "name": "Universiteit Faculteit Geneeskunde",
        "building_id": 7
    },
    {
        "name": "SAR academie",
        "building_id": 20
    }
]